/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sorter_Faq_A1Inputs */

const en_sorter_faq_a1 = /** @type {(inputs: Sorter_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes, at every level. Objects nested inside other objects and objects nested inside arrays are all sorted, independently of their parent.`)
};

const ko_sorter_faq_a1 = /** @type {(inputs: Sorter_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`그렇습니다. 모든 단계에서 적용됩니다. 다른 객체 안에 중첩된 객체와 배열 안에 중첩된 객체가 모두 부모와 독립적으로 정렬됩니다.`)
};

const ja_sorter_faq_a1 = /** @type {(inputs: Sorter_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい、すべての段階で適用されます。ほかのオブジェクトにネストしたオブジェクトも、配列にネストしたオブジェクトも、親とは独立に並べ替えられます。`)
};

/**
* | output |
* | --- |
* | "Yes, at every level. Objects nested inside other objects and objects nested inside arrays are all sorted, independently of their parent." |
*
* @param {Sorter_Faq_A1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const sorter_faq_a1 = /** @type {((inputs?: Sorter_Faq_A1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sorter_Faq_A1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sorter_faq_a1(inputs)
	if (locale === "ko") return ko_sorter_faq_a1(inputs)
	return ja_sorter_faq_a1(inputs)
});